import { Component, OnInit } from '@angular/core';
import { LANDINGPAGE_HEADER, CARDITEMLIST } from '../common/constants/labels';
import { AuthenticationService } from '../common/services/authentication.service';
import { Role } from '../common/models/role';
import { MatDialog, MatDialogModule} from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';
@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})

// Component loads the landing page of the application
export class LandingPageComponent implements OnInit {

  headerName = LANDINGPAGE_HEADER;
  cardItemlist = CARDITEMLIST;
  userName;
  name;
  role;
  loading = true;
  constructor(private adalSvc: MsalService, public dialog: MatDialog) {
  }
  openDialog() {
    const dialogRef = this.dialog.open(QWeekBannerComponent, {panelClass: 'dialog-container-custom' });

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log(`Dialog result: ${result}`);
    // });
  }
  ngOnInit() {
   // this.openDialog();
    this.loginInfo();
  }
  // method to set logged in information
  loginInfo() {
    this.name = localStorage.getItem('UserName');
    this.userName = localStorage.getItem('UserEmailAddress');
    setTimeout(() => {
      this.loading = false;
    }, 500);
    if (localStorage.getItem('role') && localStorage.getItem('role').length > 0) {
      this.role = '(' + localStorage.getItem('role') + ')';
    }
  }
  // method for logout
  logout() {
    this.adalSvc.logout();
    localStorage.clear();
  }
}

@Component({
  selector: 'app-quality-week-banner',
  templateUrl: 'quality-week-banner.html'
})
export class QWeekBannerComponent {}
